export default "__VITE_ASSET__BZoUQz4t__"